module.exports = __webpack_public_path__ + "static/media/requestPayment.84967d7f.svg";